import styled from 'styled-components'

export const ScreenContainer = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;

    .error-text {
        color: ${({ theme }) => theme.colors.danger};
    }
`

export const SectionCard = styled.div`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 16px;
`

export const FilterRow = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
    align-items: center;
`

export const ApprovalCardMetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 13px;

    .label {
        font-weight: 600;
        color: #334155;
        min-width: 96px;
        flex-shrink: 0;
    }

    .value {
        color: #0f172a;
        font-weight: 500;
    }
`

export const ApprovalStatusBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: ${({ $status, $approved }) => {
        if ($status === 'rejected') return '#fee2e2'
        if ($status === 'awaiting_others') return '#fef3c7'
        if ($status === 'awaiting_me') return '#f5f3ff'
        if ($approved || $status === 'approved') return '#ecfdf5'
        return '#fef3c7'
    }};
    color: ${({ $status, $approved }) => {
        if ($status === 'rejected') return '#dc2626'
        if ($status === 'awaiting_others') return '#b45309'
        if ($status === 'awaiting_me') return '#7c3aed'
        if ($approved || $status === 'approved') return '#065f46'
        return '#92400e'
    }};
`

export const StatusPill = styled.button`
    border: 1px solid
        ${({ $active }) => ($active ? '#2563eb' : '#d1d5db')};
    background: ${({ $active }) => ($active ? '#eff6ff' : '#fff')};
    color: ${({ $active }) => ($active ? '#1d4ed8' : '#374151')};
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        border-color: #2563eb;
    }
`

export const CounterStrip = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;

    .counter {
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 10px 14px;
        min-width: 140px;
    }

    .counter .num {
        font-size: 20px;
        font-weight: 700;
        color: #2563eb;
        line-height: 1.1;
    }

    .counter .label {
        font-size: 11px;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin-top: 4px;
    }
`

export const DetailLayout = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 340px;
    gap: 16px;
    min-height: 70vh;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`

export const PdfPanel = styled.div`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    min-height: 70vh;

    iframe {
        width: 100%;
        height: 70vh;
        border: none;
    }
`

export const SidePanel = styled.div`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;

    .meta-row {
        margin-bottom: 12px;
    }

    .meta-row label {
        display: block;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #6b7280;
        margin-bottom: 2px;
    }

    .meta-row .value {
        font-size: 14px;
        color: #111827;
        word-break: break-word;
    }
`

export const ApprovalBanner = styled.div`
    padding: 12px 16px;
    background: #ecfdf5;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
    color: #166534;
    margin-bottom: 16px;
    font-size: 14px;

    a {
        color: #15803d;
        font-weight: 600;
    }
`

export const SignatureCanvas = styled.canvas`
    width: 100%;
    height: 180px;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
    background: #fff;
    touch-action: none;
    cursor: crosshair;
`

export const SignaturePreview = styled.div`
    min-height: 120px;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    font-family: 'Segoe Script', 'Brush Script MT', cursive;
    font-size: 28px;
    color: #111827;
    background: #fafafa;
`

export const UploadDropZone = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 140px;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
    background: #fafafa;
    cursor: pointer;
    padding: 16px;
    text-align: center;
    color: #6b7280;

    input {
        display: none;
    }

    img {
        max-width: 100%;
        max-height: 120px;
        object-fit: contain;
    }
`

export const QrPreviewBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 16px 16px 20px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fafafa;
    overflow: visible;
    box-sizing: border-box;
    width: 100%;

    img {
        display: block;
        width: min(100%, 220px);
        height: auto;
        max-height: 220px;
        object-fit: contain;
        background: transparent;
        flex-shrink: 0;
    }

    .qr-preview-caption {
        display: block;
        margin: 0;
        padding: 0 4px 2px;
        font-size: 12px;
        line-height: 1.4;
        color: #6b7280;
        text-align: center;
        white-space: normal;
        overflow: visible;
    }
`

export const PageSubtitle = styled.p`
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 13px;
`

export const ApprovalBreadcrumb = styled.div`
    padding: 0 0 12px;
    font-size: 13px;
    color: #6b7280;

    button {
        background: none;
        border: none;
        color: #2563eb;
        padding: 0;
        cursor: pointer;
        font-size: 13px;
    }

    strong {
        color: #111827;
        font-weight: 600;
    }
`

export const InfoCard = styled.div`
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;

    h4 {
        margin: 0 0 10px;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #6b7280;
        font-weight: 600;
    }

    .meta-row {
        margin-bottom: 12px;
    }

    .meta-row label {
        display: block;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #6b7280;
        margin-bottom: 2px;
    }

    .meta-row .value {
        font-size: 14px;
        color: #111827;
        word-break: break-word;
    }
`

export const PdfStampBanner = styled.div`
    padding: 12px 16px;
    background: #fef3c7;
    border: 1px solid #fde68a;
    border-radius: 8px;
    color: #92400e;
    margin-bottom: 16px;
    font-size: 14px;
`

export const TimelineList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 7px;
        top: 8px;
        bottom: 8px;
        width: 2px;
        background: #e5e7eb;
    }
`

export const TimelineItem = styled.li`
    position: relative;
    padding: 0 0 20px 32px;

    &:last-child {
        padding-bottom: 0;
    }

    .dot {
        position: absolute;
        left: 0;
        top: 4px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${({ $kind }) => {
            if ($kind === 'approved' || $kind === 'submitted') return '#16a34a'
            if ($kind === 'rejected') return '#dc2626'
            if ($kind === 'pending') return '#f59e0b'
            return '#d1d5db'
        }};
        border: 3px solid white;
        box-shadow: 0 0 0 1px
            ${({ $kind }) => {
                if ($kind === 'approved' || $kind === 'submitted') return '#16a34a'
                if ($kind === 'rejected') return '#dc2626'
                if ($kind === 'pending') return '#f59e0b'
                return '#d1d5db'
            }};
    }

    .title {
        font-weight: 600;
        font-size: 14px;
    }

    .meta {
        font-size: 12px;
        color: #6b7280;
        margin-top: 2px;
    }

    .note {
        margin-top: 6px;
        padding: 8px 10px;
        background: #f9fafb;
        border-left: 2px solid #d1d5db;
        font-size: 12px;
        color: #374151;
    }

    .signature {
        margin-top: 6px;
        padding: 8px 10px;
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 4px;
        display: inline-block;
        font-family: 'Allura', 'Segoe Script', cursive;
        font-size: 20px;
        color: #2563eb;
    }

    .signature img {
        max-height: 48px;
        max-width: 180px;
        object-fit: contain;
    }
`

export const ApproverRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid ${({ $final }) => ($final ? '#7c3aed' : '#e5e7eb')};
    border-radius: 6px;
    margin-bottom: 8px;
    background: ${({ $final }) => ($final ? '#f5f3ff' : 'white')};

    .handle {
        color: #9ca3af;
        cursor: grab;
        font-size: 16px;
        line-height: 1;
    }

    .step-num {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: ${({ $final }) => ($final ? '#7c3aed' : '#f3f4f6')};
        color: ${({ $final }) => ($final ? 'white' : '#6b7280')};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 700;
        flex-shrink: 0;
    }

    .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #eef2ff;
        color: #2563eb;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 13px;
        flex-shrink: 0;
    }

    .meta {
        flex: 1;
        min-width: 0;
    }

    .meta .name {
        font-weight: 600;
    }

    .meta .email {
        font-size: 12px;
        color: #6b7280;
    }
`

export const FinalPill = styled.span`
    display: inline-block;
    margin-left: 6px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: #f5f3ff;
    color: #7c3aed;
    border: 1px solid #7c3aed;
`

export const WorkflowCallout = styled.div`
    padding: 10px 14px;
    background: ${({ $warn }) => ($warn ? '#fef3c7' : '#eef2ff')};
    border-left: 3px solid ${({ $warn }) => ($warn ? '#d97706' : '#2563eb')};
    border-radius: 6px;
    font-size: 13px;
    color: ${({ $warn }) => ($warn ? '#78350f' : '#1e3a8a')};
    margin-bottom: 20px;

    ul {
        margin: 6px 0 0 20px;
        padding: 0;
    }

    li {
        margin-bottom: 4px;
    }
`

export const WorkflowSectionTitle = styled.h2`
    color: #2563eb;
    font-size: 16px;
    margin: 0 0 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 700;
`

export const WorkflowHelp = styled.p`
    font-size: 12px;
    color: #6b7280;
    margin: 0 0 10px;
    line-height: 1.5;

    code {
        font-size: 11px;
    }
`

export const WorkflowDivider = styled.div`
    height: 1px;
    background: #e5e7eb;
    margin: 20px 0;
`

export const WorkflowHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 4px;
`

export const ProgressTrack = styled.div`
    width: 100%;
    height: 8px;
    background: #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 6px;

    > div {
        height: 100%;
        background: #2563eb;
        width: ${({ $pct }) => `${$pct || 0}%`};
    }
`

export const LandingGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 20px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`

export const WideActionButton = styled.button`
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    border-radius: 6px;
    border: 1px solid
        ${({ $ghost, $locked }) => ($locked || $ghost ? '#d1d5db' : 'transparent')};
    background: ${({ $ghost, $locked, $ok }) => {
        if ($locked) return '#f3f4f6'
        if ($ok) return '#16a34a'
        if ($ghost) return 'white'
        return '#2563eb'
    }};
    color: ${({ $ghost, $locked }) => {
        if ($locked) return '#9ca3af'
        if ($ghost) return '#374151'
        return 'white'
    }};
    font-size: 14px;
    font-weight: 500;
    cursor: ${({ $locked }) => ($locked ? 'not-allowed' : 'pointer')};
    margin-bottom: 8px;
    opacity: ${({ $locked }) => ($locked ? 0.6 : 1)};
`
